import React from 'react'
import { t } from 'ttag'

import { Modal } from 'components/shared/Modal/Modal'
import { useFormState } from 'components/modals/SavePositionTemplateModal/hooks'
import { CreateTemplate } from 'components/modals/SavePositionTemplateModal/common/CreateTemplate/CreateTemplate'
import { mapInternalStateToPayload } from 'components/modals/SavePositionTemplateModal/actions'
import styles from './CreateTemplateModal.module.scss'
import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { useInternalState } from './hooks'
import { TEMPLATE_NAME_FIELD } from 'components/modals/SavePositionTemplateModal/common/CreateTemplate/model'

export const CreateTemplateModal = ({
  project,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => {
  const [formState, setFormState] = React.useState({
    [TEMPLATE_NAME_FIELD]: '',
  })

  const data = React.useMemo(
    () => mapInternalStateToPayload({ ...project, ...formState }),
    [formState, project],
  )

  const { create } = useFormState(setFormState)

  const {
    handleCancel,
    handleClose,
    handleConfirm,
    handleConfirmationClose,
    handleConfirmationConfirm,
    isConfirmationOpen,
  } = useInternalState(
    { create, data, isOpen },
    { onCancel, onClose, onConfirm },
  )

  return (
    <>
      <Modal
        className={styles.modal}
        cancelLabel={t`Cancel`}
        confirmLabel={t`Save`}
        title={t`Create template based on ${project.name} job`}
        onCancel={handleCancel}
        onClose={handleClose}
        onConfirm={handleConfirm}
        {...{ isOpen }}
      >
        <Modal.Header />
        <Modal.Content className={styles.content}>
          <CreateTemplate {...{ ...create }} />
        </Modal.Content>
        <Modal.Footer />
      </Modal>
      <DoubleConfirmationModal
        onCancel={handleConfirmationClose}
        onClose={handleConfirmationClose}
        onConfirm={handleConfirmationConfirm}
        isOpen={isConfirmationOpen}
      />
    </>
  )
}
